import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

const FeaturesListManager = ({ sectionId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    category: 'Jurerê',
    is_intro: false,
    icon_class: '',
    title: '',
    description: ''
  });

  const loadItems = useCallback(async () => {
    try {
      const res = await api.get(`/admin/sections/${sectionId}/items`);
      setItems(res.data || []);
    } catch (err) {
      console.error("Erro ao carregar itens", err);
    }
  }, [sectionId]);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (editingId) {
        await api.put(`/admin/items/${editingId}`, formData);
      } else {
        await api.post(`/admin/sections/${sectionId}/items`, formData);
      }
      
      // Reseta o form
      setFormData({ category: 'Jurerê', is_intro: false, icon_class: '', title: '', description: '' });
      setEditingId(null);
      loadItems();
    } catch (err) {
      alert("Erro ao salvar item.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setFormData({
      category: item.category || 'Jurerê',
      is_intro: item.is_intro || false,
      icon_class: item.icon_class || '',
      title: item.title || '',
      description: item.description || ''
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este item?')) return;
    try {
      await api.delete(`/admin/items/${id}`);
      loadItems();
    } catch (err) {
      alert("Erro ao excluir item.");
    }
  };

  const cancelEdit = () => {
    setEditingId(null);
    setFormData({ category: 'Jurerê', is_intro: false, icon_class: '', title: '', description: '' });
  };

  return (
    <div className="row">
      {/* COLUNA DO FORMULÁRIO */}
      <div className="col-md-5 border-end pe-4">
        <h6 className="fw-bold mb-3 text-primary">{editingId ? 'Editar Item' : 'Novo Item'}</h6>
        <form onSubmit={handleSubmit}>
          
          <div className="mb-3">
            <label className="form-label fw-bold small">CIDADE / CATEGORIA</label>
            <select name="category" className="form-select" value={formData.category} onChange={handleChange}>
              <option value="Jurerê">Jurerê</option>
              <option value="Floripa">Florianópolis</option>
            </select>
          </div>

          <div className="mb-3 p-3 bg-light border rounded">
            <div className="form-check form-switch">
              <input className="form-check-input" type="checkbox" name="is_intro" id="isIntroCheck" checked={formData.is_intro} onChange={handleChange} />
              <label className="form-check-label fw-bold text-dark" htmlFor="isIntroCheck">
                É apenas Texto Introdutório?
              </label>
            </div>
            <small className="text-muted d-block mt-1">Marque isso se for o parágrafo inicial. Se desmarcado, será um item da lista com ícone.</small>
          </div>

          {/* SÓ MOSTRA ÍCONE E TÍTULO SE NÃO FOR TEXTO INTRODUTÓRIO */}
          {!formData.is_intro && (
            <div className="row">
              <div className="col-md-5 mb-3">
                <label className="form-label fw-bold small">CLASSE DO ÍCONE</label>
                <input type="text" name="icon_class" className="form-control" placeholder="Ex: bi-water" value={formData.icon_class} onChange={handleChange} required={!formData.is_intro} />
                <a href="https://icons.getbootstrap.com/" target="_blank" rel="noreferrer" className="small text-decoration-none">Ver ícones</a>
              </div>
              <div className="col-md-7 mb-3">
                <label className="form-label fw-bold small">TÍTULO (Ex: Praia Familiar)</label>
                <input type="text" name="title" className="form-control" value={formData.title} onChange={handleChange} required={!formData.is_intro} />
              </div>
            </div>
          )}

          <div className="mb-4">
            <label className="form-label fw-bold small">TEXTO / DESCRIÇÃO</label>
            <textarea name="description" className="form-control" rows="4" value={formData.description} onChange={handleChange} required></textarea>
          </div>

          <div className="d-flex gap-2">
            <button type="submit" className="btn btn-dark fw-bold px-4" disabled={loading}>
              {loading ? 'Salvando...' : 'SALVAR ITEM'}
            </button>
            {editingId && (
              <button type="button" className="btn btn-outline-danger" onClick={cancelEdit}>Cancelar</button>
            )}
          </div>
        </form>
      </div>

      {/* COLUNA DA LISTAGEM */}
      <div className="col-md-7 ps-4">
        <h6 className="fw-bold mb-3 text-primary">Itens Cadastrados</h6>
        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
          
          {items.length === 0 ? (
            <div className="alert alert-light text-center">Nenhum item cadastrado ainda.</div>
          ) : (
            <div className="list-group">
              {items.map(item => (
                <div key={item.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center mb-2 border rounded shadow-sm">
                  
                  <div className="d-flex align-items-start gap-3 w-100">
                    {/* Exibe o ícone ou um alerta de intro */}
                    <div className="mt-1 text-center" style={{ width: '40px' }}>
                      {item.is_intro ? (
                        <span className="badge bg-secondary"><i className="bi bi-justify fs-6"></i></span>
                      ) : (
                        <i className={`bi ${item.icon_class} fs-3 text-primary`}></i>
                      )}
                    </div>
                    
                    <div>
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <span className={`badge ${item.category === 'Jurerê' ? 'bg-success' : 'bg-info text-dark'}`}>
                          {item.category}
                        </span>
                        {item.is_intro && <span className="badge bg-warning text-dark">Intro</span>}
                      </div>
                      
                      {!item.is_intro && <h6 className="fw-bold mb-1">{item.title}</h6>}
                      <p className="mb-0 small text-muted text-truncate" style={{ maxWidth: '350px' }}>
                        {item.description}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex gap-2 ms-3">
                    <button className="btn btn-sm btn-outline-primary" onClick={() => handleEdit(item)}><i className="bi bi-pencil"></i></button>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(item.id)}><i className="bi bi-trash"></i></button>
                  </div>
                  
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturesListManager;